import {FieldRenderProps} from "@progress/kendo-react-form"
import {TextArea} from "@progress/kendo-react-inputs"
import {FloatingLabel} from "@progress/kendo-react-labels"
import React from "react"

const TextAreaInput = (fieldRenderProps: FieldRenderProps): JSX.Element => {
    const {label, id, value, onChange, required, bookingID} = fieldRenderProps
    return (
        <FloatingLabel
            className={"k-textarea-container bk-notes-textarea"}
            label={label}
            editorId={id}
            editorValue={value}
        >
            <div className={"k-form-field-wrap"}>
                <TextArea
                    id={id}
                    value={value}
                    onChange={onChange}
                    rows={4}
                    required={required}
                    valid={bookingID === 0 ? true : required ? (value.trim().length === 0 ? false : true) : true}
                    validationMessage={value.trim().length === 0 ? "Note required for cancel booking" : ""}
                />
            </div>
        </FloatingLabel>
    )
}
export default React.memo(TextAreaInput)
